import { NgModule } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';

import { FranchiseComponent }               from './franchise.component';
import { FranchisesOwnerSettingsComponent } from './franchises.owner-settings.component';
import { FranchisesService }                from './franchises.service';
import { FranchisesSettingsComponent }      from './franchises.settings.component';
import { FranchisesStates }                 from './franchises.states';
import { SharedModule }                     from '../shared/shared.module';
import { TableModule }                      from '../table/table.module';

@NgModule({
  declarations: [
    FranchiseComponent,
    FranchisesOwnerSettingsComponent,
    FranchisesSettingsComponent
  ],
  entryComponents: [
    FranchiseComponent,
    FranchisesOwnerSettingsComponent,
    FranchisesSettingsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterModule.forChild({ states: FranchisesStates })
  ],
  providers: [
    FranchisesService
  ]
})
export class FranchisesModule {}
